var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainingMatrixIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "training-matrix-icon",
    transform: "translate(-36.45 -487.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M11.484,14H3.515A3.408,3.408,0,0,1,0,10.719V6.1A3.408,3.408,0,0,1,3.515,2.817H5.859a.569.569,0,0,1,.587.547.569.569,0,0,1-.587.547H3.515A2.272,2.272,0,0,0,1.172,6.1v4.621a2.272,2.272,0,0,0,2.344,2.188h7.969a2.273,2.273,0,0,0,2.344-2.188V7.575a.587.587,0,0,1,1.172,0v3.144A3.409,3.409,0,0,1,11.484,14Zm-.175-7.109A3.578,3.578,0,0,1,7.618,3.446,3.579,3.579,0,0,1,11.309,0,3.579,3.579,0,0,1,15,3.446,3.579,3.579,0,0,1,11.309,6.891Zm0-5.8A2.442,2.442,0,0,0,8.789,3.446,2.442,2.442,0,0,0,11.309,5.8a2.443,2.443,0,0,0,2.52-2.351A2.443,2.443,0,0,0,11.309,1.094Z",
    transform: "translate(36.45 487.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M5.156,8.119a3.656,3.656,0,0,1-2.132-.67L.231,5.467A.536.536,0,0,1,0,5.1.519.519,0,0,1,.12,4.7a.6.6,0,0,1,.467-.215A.605.605,0,0,1,.941,4.6L3.734,6.579a2.485,2.485,0,0,0,2.843,0l.977-.7a.607.607,0,0,1,.356-.113.6.6,0,0,1,.465.215.518.518,0,0,1,.116.4.537.537,0,0,1-.225.367l-.977.7A3.708,3.708,0,0,1,5.156,8.119Zm3.809-5.33a.568.568,0,0,1-.586-.547V1.094A.569.569,0,0,1,7.793.547.568.568,0,0,1,8.379,0h.586a.568.568,0,0,1,.586.547V2.242A.568.568,0,0,1,8.965,2.789Z",
    transform: "translate(38.794 489.087)",
    fill: "#eb742e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingMatrixIcon);
export default __webpack_public_path__ + "static/media/training-matrix-icon.3a9d64e0bd5464e6351f3bf3342e2012.svg";
export { ForwardRef as ReactComponent };